import { ContentItemPreviewSnippet, ImportResponse, ContentType, ContentResponse } from "@authory-packages/core";
import { ItemPreviewFormik } from "../../ItemPreviewEdit";

export enum FileUploadTarget {
    PDF = "PDF",
    Website = "Website",
    Email = "Email",
    Image = "Image",
    CustomVideo = "CustomVideo",
    CustomAudio = "CustomAudio"
}

export interface V3ImportManualFormik {
    url?: string;
}

export interface ImportItem {
    url?: string | null;
    contentRes?: ImportResponse;
    snippetRes?: ContentItemPreviewSnippet;
    /** Item already in the account that matched this url on the duplicate check. Undefined means no duplicate. */
    duplicate?: ContentResponse;
    files?: File[];
    uploadId?: string;
    fileUploadTarget?: FileUploadTarget;
    id: string;
}

export interface FinalImportResult extends V3ImportManualFormik, ItemPreviewFormik {
    importResult?: ImportResponse;
    type: ContentType;
    isSnippetOnlydomain: boolean;
    /** Canonical url of the page, when the metadata lookup found one */
    canonicalUrl?: string;
}

export enum UnifiedAddContentStages {
    ChooseType = "ChooseType",
    ArticleOptions = "ArticleOptions",
    PodcastOptions = "PodcastOptions",
    PodcastEpisodeOptions = "PodcastEpisodeOptions",
    VideoOptions = "VideoOptions",
    YouTubeOptions = "YouTubeOptions",
    SocialMediaOptions = "SocialMediaOptions",
    LinkedInOptions = "LinkedInOptions",
    PDFOptions = "PDFOptions",
    ScreenshotOptions = "ScreenshotOptions",
    Spotify = "Spotify",
    AddSource = "AddSource",
    AddManual = "AddManual",
    ContentUpload = "ContentUpload",
    WebsiteAddURL = "WebsiteAddURL",
    AddContentEmail = "AddContentEmail",
    AddContentEmailFinished = "AddContentEmailFinished",
    CollectionEditRules = "CollectionEditRules",
    CollectionChooseOptions = "CollectionChooseOptions",
    CollectionManualBulkAdd = "CollectionManualBulkAdd",
    AutoUpdate = "AutoUpdate",
    Image = "Image"
}
